import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, ShieldCheckIcon, SparklesIcon } from 'lucide-react';
export function IntroSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white relative overflow-hidden" data-id="element-74">
      {/* Subtle decorative element */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-wellness-sage/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-75" />

      <div className="max-w-4xl mx-auto relative" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="text-center mb-12" data-id="element-77">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-rose-50 text-rose-400 mb-6" data-id="element-78">
            <HeartIcon className="w-7 h-7" data-id="element-79" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight mb-2" data-id="element-80">
            Esto{' '}
            <span className="text-wellness-accent italic font-serif" data-id="element-81">
              no es
            </span>{' '}
            otra dieta <br className="hidden sm:block" data-id="element-82" />
            para sufrir.
          </h2>
        </motion.div>

        {/* Empathetic letter-style content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.15
      }} className="bg-wellness-sage/15 rounded-[2rem] p-8 sm:p-10 md:p-12 border border-wellness-sage/30 mb-12" data-id="element-83">
          <div className="space-y-5 text-lg sm:text-xl text-wellness-text/85 leading-relaxed" data-id="element-84">
            <p data-id="element-85">
              Si tienes{' '}
              <strong className="text-wellness-primary font-semibold" data-id="element-86">
                más de 65 años
              </strong>
              , vives en Estados Unidos y ya estás cansada de que te digan{' '}
              <em data-id="element-87">"haz ejercicio"</em> y <em data-id="element-88">"come mejor"</em> como si fuera tan
              fácil…
            </p>
            <p data-id="element-89">
              <strong className="text-wellness-primary font-semibold" data-id="element-90">
                Te entiendo.
              </strong>
            </p>
            <p data-id="element-91">
              No estás para rutinas agresivas en el gimnasio. No quieres contar
              calorías ni pasar hambre. Y probablemente ya intentaste varias
              dietas que solo te dejaron frustrada.
            </p>
            <p data-id="element-92">
              Este plan es diferente. Fue pensado para ti:{' '}
              <strong className="text-wellness-primary font-semibold" data-id="element-93">
                comida real, porciones normales, sin sufrimiento.
              </strong>{' '}
              Nada extremo. Nada complicado. Solo alimentos que ayudan a tu
              cuerpo a desinflamarse naturalmente.
            </p>
          </div>
        </motion.div>

        {/* Three reassurance points */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-94">
          {[{
          icon: ShieldCheckIcon,
          title: 'Sin dietas agresivas',
          text: 'Nada de pasar hambre ni eliminar grupos de alimentos. Comes bien, comes rico.'
        }, {
          icon: HeartIcon,
          title: 'A tu ritmo',
          text: 'Caminar, estirarte, moverte suave. Nada de rutinas intensas que no van contigo.'
        }, {
          icon: SparklesIcon,
          title: 'Resultados reales',
          text: 'Menos hinchazón, más energía y mejor digestión en solo 14 días.'
        }].map((item, idx) => {
          const Icon = item.icon;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1 * idx + 0.3,
            duration: 0.5
          }} className="text-center p-6" data-id="element-95">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-wellness-sage/30 text-wellness-medium mb-4" data-id="element-96">
                  <Icon className="w-6 h-6" data-id="element-97" />
                </div>
                <h3 className="text-lg font-serif font-semibold text-wellness-primary mb-2" data-id="element-98">
                  {item.title}
                </h3>
                <p className="text-wellness-text/70 leading-relaxed" data-id="element-99">
                  {item.text}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}